import React from 'react';
import styled, { css } from 'styled-components';
import { Option } from '../inputs/base/DropDown';

// Import all shipment type icons
import AE from '../../../static/icons/shipmentTypes/AE.svg';
import AI from '../../../static/icons/shipmentTypes/AI.svg';
import AIR from '../../../static/icons/shipmentTypes/AIR.svg';
import CUSTOMS from '../../../static/icons/shipmentTypes/CUSTOMS.svg';
import DROP_AIR from '../../../static/icons/shipmentTypes/DROP_AIR.svg';
import DROP_OCEAN from '../../../static/icons/shipmentTypes/DROP_OCEAN.svg';
import EXPRESS from '../../../static/icons/shipmentTypes/EXPRESS.svg';
import INLAND from '../../../static/icons/shipmentTypes/INLAND.svg';
import OCEAN from '../../../static/icons/shipmentTypes/OCEAN.svg';
import OCEAN_FCL from '../../../static/icons/shipmentTypes/OCEAN_FCL.svg';
import OCEAN_LCL from '../../../static/icons/shipmentTypes/OCEAN_LCL.svg';
import OE from '../../../static/icons/shipmentTypes/OE.svg';
import OEX from '../../../static/icons/shipmentTypes/OEX.svg';
import OI from '../../../static/icons/shipmentTypes/OI.svg';
import RAIL from '../../../static/icons/shipmentTypes/RAIL.svg';

// Map of shipment types to their icons
const shipmentTypeIcons: Record<string, string> = {
    AE,
    AI,
    AIR,
    CUSTOMS,
    DROP_AIR,
    DROP_OCEAN,
    EXPRESS,
    INLAND,
    OCEAN,
    OCEAN_FCL,
    OCEAN_LCL,
    OE,
    OEX,
    OI,
    RAIL
};

type Props = {
    text: string;
    value: string;
    size?: string;
    hideOptionBorder?: boolean;
};

const ShipmentTypeOption = ({ text, value, size, hideOptionBorder }: Props) => {
    if (!value) return null;
    const typeIcon = shipmentTypeIcons[value];
    if (!typeIcon) return null;
    
    return (
        <Wrapper hideBorder={hideOptionBorder}>
            <Icon alt={text} src={typeIcon} width={size} marginRight={'6px'} /> <Text> {text} </Text>
        </Wrapper>
    );
};

export const renderShipmentTypeOption = (option: Option) => {
    return <ShipmentTypeOption text={option.text} value={option.value} />;
};

type WrapperProps = {
    hideBorder?: boolean;
};

const Wrapper = styled.div<WrapperProps>`
    display: flex;
    justify-content: left;
    align-items: center;
    ${(props) =>
        !props.hideBorder
            ? css`
                  border-bottom: 1px solid #dadada;
              `
            : ''};
    padding-bottom: 3px;
`;

type IconProps = {
    width?: string;
    marginRight?: string;
};

const Icon = styled.img<IconProps>`
    width: ${(props) => props.width ?? '20px'};
    ${(props) =>
        props.marginRight
            ? css`
                  margin-right: ${props.marginRight};
              `
            : ''}
`;

const Text = styled.div`
    color: ${(props) => props.theme.colors.gridCell};
    font-size: ${(props) => props.theme.fontSizes.gridCell};
    font-weight: 400;
`;

export default ShipmentTypeOption;
